import { useState, useCallback, useMemo } from 'react';

import { EditorState } from 'draft-js';

import { isEditorEmpty, makeEditorState } from '@utils/draftjs';

export function useEditorState(initialValue: string | EditorState) {
  const [editorState, setEditorState] = useState(() => makeEditorState(initialValue));
  const [storedInitial] = useState(() => editorState);

  const resetEditorState = useCallback(() => {
    setEditorState(storedInitial);
  }, [storedInitial]);

  const isEmpty = useMemo(() => isEditorEmpty(editorState), [editorState]);

  return {
    editorState,
    setEditorState,
    resetEditorState,
    isEmpty,
  };
}
